import { Component, Inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogRef,
  MatDialogClose,
  MatDialogTitle,
  MatDialogContent,
  MatDialogActions,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { genThumbMediaURI, isMediaInfoPublishable, PropertyMediaInfo } from '../../image';
import { MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { FormsModule } from '@angular/forms';
import { CdkScrollable } from '@angular/cdk/scrolling';

import { BgImageComponent } from '../bg-image.component';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatRadioButton } from '@angular/material/radio';

export interface AdditionalImageDialogInputData {
  imagesToDisplay: PropertyMediaInfo[];
  multiSelect: boolean;
  edpMultimediaURI: string;
  s3BucketImagesUrl: string;
  selectedImageId?: number;
  navigationMessage?: boolean;
  availabilityId?: number;
  translatedData: {
    close: string;
    selectAttachment: string;
    select: string;
    noImagesFound: string;
    navigationMessage?: string;
    addNew?: string;
  };
}

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'additional-image-dialog',
  templateUrl: './add-additional-image-dialog.html',
  styleUrl: './add-additional-image-dialog.scss',
  imports: [
    MatButton,
    MatDialogClose,
    MatIcon,
    MatDialogTitle,
    FormsModule,
    CdkScrollable,
    MatDialogContent,
    BgImageComponent,
    MatCheckbox,
    MatRadioButton,
    MatDialogActions
],
})
export class AddAdditionalImageDialogComponent implements OnInit {
  public imagesToDisplay: PropertyMediaInfo[];
  public multiSelect: boolean;
  public edpMultimediaURI: string;
  public imageLocationURI: string;
  public images = [];
  public selectedMediaID: number;
  public selectedMedia: PropertyMediaInfo;
  public navigationMessage: boolean = false;
  public translatedData;
  public availabilityId: number;

  constructor(
    public dialogRef: MatDialogRef<AddAdditionalImageDialogComponent>,
    @Inject(MAT_DIALOG_DATA) data: AdditionalImageDialogInputData,
    private router: Router
  ) {
    this.imagesToDisplay = data.imagesToDisplay;
    this.multiSelect = data.multiSelect;
    this.edpMultimediaURI = data.edpMultimediaURI;
    this.imageLocationURI = data.s3BucketImagesUrl;
    this.selectedMediaID = data.selectedImageId;
    this.translatedData = data.translatedData;
    this.navigationMessage = data.navigationMessage;
    this.availabilityId = data.availabilityId;
    if (this.selectedMediaID) {
      this.selectedMedia = this.imagesToDisplay.find(image => image.id === this.selectedMediaID);
    }
  }
  ngOnInit() {
    if (this.imagesToDisplay.length) {
      this.images = this.imagesToDisplay.map(media => ({
        ...media,
        sanitized_media_path: genThumbMediaURI(this.edpMultimediaURI, this.imageLocationURI, media.media_path),
        publishable: isMediaInfoPublishable(media),
      }));
    }
  }

  public onClose(media?: PropertyMediaInfo | PropertyMediaInfo[]) {
    this.dialogRef.close(media);
  }

  public select() {
    this.onClose(this.selectedMedia);
  }

  public selectImage(media?: PropertyMediaInfo) {
    this.selectedMedia = media;
  }

  public navigate() {
    this.dialogRef.close();
    this.router.navigateByUrl(`/records/availability/${this.availabilityId}/attachments`);
  }
}
